<template>
  <div class="news-list">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getNewsList">
      <div class="item" v-for="(item, index) in newsList" :key="index" @click="toDetail(item.factorId)">
        <div class="category">
          <div class="left">
            <span class="name">{{ item.category }}</span>
            <span class="tagbg" :class="item.p1zf > 0 ? 'up' : item.p1zf == 0 ? 'flat' : 'down'">
              {{ item.tag }}
            </span>
          </div>

          <p class="time">{{ item.time }}</p>
        </div>
        <div class="content">
          <div class="left">
            <h2>
              {{ item.indexname }}
              <span>{{ item.p1zf > 0 ? "上涨" : "下跌" }}</span>
              <span :class="[judgeColor(Number(item.p1zf))]">{{ item.p1zf }}%</span>
            </h2>

            <ul class="ul">
              <li v-for="(item2, index2) in item.relatedChance" :key="index2">
                {{ index2 + 1 }}.&nbsp;{{ item2.indexname }}
                <span>{{ item2.p1zf > 0 ? "上涨" : "下跌" }}</span>
                <span :class="[judgeColor(Number(item2.p1zf))]">{{ item2.p1zf }}%</span>
              </li>
            </ul>
          </div>

          <div class="chart-line" v-if="item.factorId">
            <ChartLine :index="index" :factorId="item.factorId" :star="item.star" />
          </div>
        </div>
        <div class="correlation" v-if="item.relatedStock?.length">
          <span class="label2">相关股票</span>

          <span class="correlation_list" v-for="(item3, index3) in item.relatedStock" :key="index3" @click.stop="goToFs(item3.code)" v-show="index3 < 2">
            <span class="code">{{ item3.name }}</span>
            <span class="zf" :class="[judgeColor(Number(stockInform[item3.code]?.ZhangFu))]">{{ toFixedNum(stockInform[item3.code]?.ZhangFu, 2, "") }}%</span>
          </span>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  import ChartLine from "./ChartLine.vue";
  export default {
    components: {
      ChartLine,
    },
    props: ["handleDataLoadedNum", "yunToken"],
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        navList: [
          {
            name: "机会预警",
            value: "qlyj-yjyggyj",
          },
          {
            name: "负面舆情",
            value: "qlyj-fmyq",
          },
        ],
        newsIndex: 0,
        pageNum: 1,
        newsList: [], // 资讯列表
        isNewsResult: false, //资讯无数据
        isStarTip: false,
        starLv: ["一", "二", "三"], // 星星等级
        isMore: true, // 滚动加载
        chartDate: [], // 折线时间
        chartData: [], // 折线数
        navTop: 0,
        themeStyleVs: 1,
        emptyMsg: "加载中",
        stockInform: {},
        codes: "",
      };
    },
    mounted() {
      this.token = this.$route.query.token;
      this.themeStyleVs = this.$route.query.themeStyleVs;
    },
    watch: {},
    methods: {
      judgeColor(n) {
        if (n == 0) {
          return "gray";
        } else if (n > 0) {
          return "red";
        } else if (n < 0) {
          return "green";
        }
      },
      toFixedNum(value, toFixed, unit) {
        if (value === null || value === undefined || isNaN(Number(value))) {
          return "--"; // 处理 null、undefined 和 NaN 的情况
        }

        if (typeof value === "number" || !isNaN(Number(value))) {
          const parsedValue = typeof value === "number" ? value : parseFloat(value);
          const formattedValue = parsedValue.toFixed(toFixed);
          const paddedValue = formattedValue.padStart(formattedValue.indexOf(".") + 3, "0"); // 保留两位小数

          if (parsedValue !== 0) {
            return paddedValue + unit;
          } else {
            return "0.00" + unit;
          }
        } else {
          return "--";
        }
      },
      // 获取资讯列表
      getNewsList() {
        let _this = this;
        _this.isMore = false;
        _this.emptyMsg = "加载中";

        _this
          .$http({
            method: "post",
            url: window.config.api_v1 + "/research-industry-sdk/industry-prosperity/jhyj",
            data: {
              qid: new Date().getTime(),
              pageNumber: _this.pageNum,
              pageSize: 20,
            },
            headers: {
              token: _this.token,
            },
          })
          .then((res) => {
            // 加载状态结束
            _this.loading = false;

            if (res.data.code == 0) {
              _this.newsList.push(...res.data.data.data);
              // 数据全部加载完成
              if (res.data?.data?.data?.length < 20) {
                _this.finished = true;
              } else {
                _this.pageNum += 1;
              }
            } else {
              _this.finished = true;
            }

            if (_this.handleDataLoadedNum == 7) {
              _this.$emit("data-loaded"); // 发出事件通知父组件数据已经加载完毕
            }

            const codes = res.data.data.data.reduce((accumulator, item) => {
              if (item.relatedStock) {
                item.relatedStock.slice(0, 2).forEach((stock) => accumulator.push(stock.code)); // 只取前两个
              }
              return accumulator;
            }, []);

            _this.codes = codes.toString();

            _this.getStocksZf(codes.toString());
          })
          .catch((err) => {
            console.log(err);
          });
      },

      // 请求实时行情数据
      getStocksZf: function (code) {
        var _this = this;
        if (!_this.websocket) {
          _this.websocket = new WebSocket(window.config.yunwsurl + "?token=" + _this.yunToken);
          _this.websocket.onopen = function () {
            _this.websocketSend(code);
          };
        }
        _this.websocket.onmessage = function (evt) {
          var fr = new FileReader();
          fr.readAsText(evt.data);
          fr.onload = function () {
            var result = JSON.parse(fr.result);

            var dynaList = result.Data.RepDataStkData;

            // 使用 reduce 方法将每一项转换成键值对
            _this.stockInform = {
              ..._this.stockInform, // 保留旧数据
              ...dynaList.reduce((accumulator, current) => {
                const key = current.Obj; // 获取键名
                accumulator[key] = current; // 使用原对象作为值
                return accumulator;
              }, {}),
            };
          };
        };
      },

      websocketSend: function (code) {
        var url = "/quote/stkdata?obj=" + code + "&field=ZhongWenJianCheng,ZuiXinJia,ZhangFu,LiuTongShiZhi,ShiYingLvPPE&qid=1";
        this.websocket.send(url);
      },

      //跳转原生分时
      goToFs: function (stockCode) {
        let newCode = stockCode.replace("B$", "BI");
        if (window.navigator.userAgent.indexOf("dzhapp") !== -1 || typeof window.DzhAppJs != "undefined") {
          this.toUrl(`dzh_browser_url&goto=0&type=2970&code=${newCode}&kind=1`);
        } else {
          let d = `dzh_browser_url&goto=0&type=2970&code=${newCode}&kind=1`;
          let url = encodeURIComponent(d);
          this.toUrl(`https://dzhopenapp.gw.com.cn/openapp/download.html?info=${url}`);
        }
      },

      //点击详细解读 跳转  行业景气
      toDetail(indexId) {
        // let data = {
        //   curZf: item.p1zf || "",
        //   d7Zf: item.d7zf || "",
        //   d30Zf: item.d30zf || "",
        //   d60Zf: item.d60zf || "",
        //   d90Zf: item.d90zf || "",
        //   ys2curZf: item.ys2czf || "",
        //   indexId: item.factorId || "",
        //   factor: {
        //     indexid: item.factorId || "",
        //     indexname: item.indexname || "",
        //     updateFreqStr: item.updateFreqStr || "",
        //   },
        //   industryName: item.industryName || "",
        //   yptIndustryCode: item.yptIndustryCode || "",
        // };

        // let _this = this;
        // let a = _this.$base64.encode(encodeURIComponent(JSON.stringify(data)));
        // const url = window.config.hyjq_detail;

        // location.href = `${url}/hyjqDetail?DZHSPECIAL=4194305&token=${_this.$route.query.token}&item=${a}`;
        let _this = this;

        const url = window.config.hyjq_detail;

        this.toUrl(`${url}/hyjqDetail?DZHSPECIAL=4194569&themeStyleVs=${_this.themeStyleVs}&indexId=${indexId}`);
      },
    },
    beforeDestroy() {
      this.websocket.send("/cancel?qid=1");
      window.onscroll = () => {};
    },
  };
</script>

<style lang="scss" scoped>
  .news-list {
    padding: 0 0.16rem;
    height: calc(100vh - 0.86rem);
    overflow-y: auto;
    .item {
      position: relative;
      padding: 0.12rem;
      background: #ffffff;
      border-radius: 16px;
      box-shadow: 0px 0px 20px rgba(109, 152, 193, 0.25);
      margin-top: 0.12rem;
      &.blur {
        filter: blur(9px);
      }
      &.visited {
        h2 {
          color: #999;
        }
      }
      &:before {
        @include border(top, #f8f8f8);
      }
      &:first-child {
        &::before {
          display: none;
        }
      }
      .category {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tagbg {
          font-style: oblique;
          display: inline-block;
          width: 0.71rem;
          height: 0.26rem;
          line-height: 0.24rem;
          text-align: center;
          font-size: 0.13rem;
          color: #fff;
        }
        .up {
          background: url("../assets/images/up.png") no-repeat;
          background-size: 100% 100%;
        }
        .down {
          background: url("../assets/images/down.png") no-repeat;
          background-size: 100% 100%;
        }
        .left {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            font-weight: 600;
            color: #1d2129;
            font-size: 0.16rem;
          }
        }
        .time {
          color: #949da8;
          font-size: 0.12rem;
        }
      }

      .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          width: 74%;
        }
        .chart-line {
          width: 0.76rem;
          height: 0.4rem;
        }
      }
      h2 {
        font-size: 0.16rem;
        color: #555;
        @include line-clamp(2);
        line-height: 0.22rem;
        margin-top: 0.1rem;
        &.w100 {
          width: 100%;
        }
      }

      .ul {
        li {
          color: #555555;
          font-size: 0.12rem;
          margin-top: 0.05rem;
          &:first-child {
            margin-top: 0.1rem;
          }
        }
      }
      .correlation {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 0.15rem;
        .label2 {
          color: #949da8;
          font-size: 0.12rem;
          flex-shrink: 0;
          width: 0.54rem;
        }

        .correlation_list {
          background: #f7f7fc;
          border-radius: 6px;
          display: flex;
          align-items: center;
          padding: 0.02rem 0.08rem;
          margin-left: 0.1rem;

          .code {
            margin-right: 0.05rem;
            font-size: 0.12rem;
          }
          .zf {
            font-weight: 500;
            font-size: 0.12rem;
          }
        }
      }
    }
  }

  .blackTheme {
    .news-list {
      .item {
        background: #171922;
        &.visited {
          h2 {
            color: #6b7687;
          }
        }
        &:before {
          @include border(top, #1e1f29);
        }
        h2 {
          color: #e4e9fe;
        }
      }

      .category {
        .left {
          .name {
            color: #e4e9fe;
          }
        }
        .time {
          color: #6b7687;
        }
      }

      .content {
        .left {
          .ul {
            li {
              color: #6b7687;
            }
          }
        }
      }

      .correlation {
        .correlation_list {
          background: #272935;
          color: #e4e9fe;
        }
      }
    }
  }
</style>
